import ManualSection from './ManualSection';

export default ManualSection;
